'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // React component based on pp-vx design
// https://github.paypal.com/pages/PayPal-UI-R/pp-vx/#icons


var sizes = {
  xs: 'ppvx_icon--size_xs',
  sm: 'ppvx_icon--size_sm',
  md: 'ppvx_icon--size_md',
  lg: 'ppvx_icon--size_lg',
  xl: 'ppvx_icon--size_xl',
  xl2: 'ppvx_icon--size_xl2'
};

function Icon(props) {
  var className = props.className,
      name = props.name,
      size = props.size,
      title = props.title,
      rest = _objectWithoutProperties(props, ['className', 'name', 'size', 'title']);

  var classNames = (0, _classnames2.default)('ppvx_icon', className, name, sizes[size]);

  return _react2.default.createElement('span', _extends({ className: classNames, title: title }, rest));
}

Icon.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xl2']),
  title: _propTypes2.default.string
};

Icon.defaultProps = {
  className: '',
  size: 'md',
  title: 'Paypal',
  // eslint-disable-next-line react/default-props-match-prop-types
  name: 'ppvx_icon-logo-paypal'
};

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/icon/jsx/Icon.js
// module id = 459
// module chunks = 4